import axios from "../../interceptor/ApiInterceptor"
import { useEffect, useState } from "react"
import toast from "react-hot-toast"
import { useSelector } from "react-redux"
import { MaterialIcon } from "../../components/Icons"
import pdfExample from './pdfExample.json'

export const usePatientsResultsList = () => {
  const [ results, setResults ] = useState([])
  const [filteredResults, setFilteredResults] = useState([])
  const [errorModal, setErrorModal] = useState({show: false, text: ""})
  const user = useSelector(state => state.auth.user)

  const BE_URL = process.env.REACT_APP_JAVA_BE_URL //114858
  const options = { headers: { Authorization: `Bearer ${user?.token}` } }

  const searchResults = () => {
    const url = `${BE_URL}/external/api/v1/pdf/patient/requests`
    


    let data = {
      idType: user?.idType, 
      idNumber: user?.idNumber,
      //mp: Number.isInteger(user.mp) ? user.mp : 0,
      mp: user.mp && user.mp !== '' && !isNaN(parseInt(user.mp, 10)) ? parseInt(user.mp, 10) : 0,
      //mn: Number.isInteger(user.mn) ? user.mn : 0
      mn: user.mn && user.mn !== '' && !isNaN(parseInt(user.mn, 10)) ? parseInt(user.mn, 10) : 0,
    }


    
    axios.post(url, data,  options)
      .then(res => {
        console.log(res.data);
        if(res.data){
          const newResults = res.data.map(result => {return {...result, fullName: `${result.apellido} ${result.nombre}`}})
          setResults(newResults)
          setFilteredResults(newResults)
        } 
      })
      .catch(error => {
        console.log(error);
      })
  }
  useEffect(() => {
    if (user?.idType && user?.idNumber) {
      searchResults();
    }
  }, [user]); // Se ejecuta solo cuando `user` cambia y tiene valores

  const downloadPDF = (number) => {
    const url = `${BE_URL}/external/api/v1/pdf/user/requests/pdf`
    let data = {
      requestNumber: number
    }
    axios.post(url, data, options)
      .then(res => {
        console.log(res.data);

        if(res.data.filedata) {
          const downloadLink = document.createElement("a");
          downloadLink.href = `data:application/pdf;base64,${res.data.filedata}`;
          downloadLink.download = res.data.filename;
          downloadLink.click()
        } else if (res.data.errorCode === 200) {
          const isAdministrative = res.data.errorMessage.includes('cuota permitida')

          setErrorModal({
            show: true, 
            text: "",
            title: `${isAdministrative ? 'Trámite administrativo pendiente de finalización' : 'Su solicitud está en proceso'}. Ante cualquier duda comuníquese por alguno de los siguientes medios:`,
            type: "info"
          })
        }
      })
      .catch(error => {
        console.log(error);

        toast({
          title: 'Error descargando el archivo',
          desc: 'Intentá nuevamente en unos minutos.',
          type: "error",
          icon: <MaterialIcon icon="error" />
        })
      })
  }

  const filterResults = (value) => {
    setFilteredResults(
      results.filter(result => result.fullName.replace(/ /g, "").toUpperCase().startsWith(value.replace(/ /g, "").toUpperCase()))
    )
  }
 
  

  return {
    results: filteredResults, downloadPDF, user, filterResults, canSearch: results.length > 0, errorModal, setErrorModal
  }
}